export default __webpack_public_path__ + "static/media/groundplan_s_84b.5161af34.png";